import type {
  AnalyticsEventName,
  AnalyticsProperties,
} from '@foodlista/shared/analytics/types'
import { usePostHogClient } from '../composables/usePostHogClient'

export function useCaptureEvent() {
  const posthog = usePostHogClient()

  return function captureEvent<Event extends AnalyticsEventName>(
    event: Event,
    properties: AnalyticsProperties<Event>,
  ) {
    posthog?.capture(event, {
      ...properties,
      source_app: 'business-web',
    })
  }
}
